function mergeDeepObjects<T extends Record<string, any>>(target: T, ...sources: Partial<T>[]): T {
  if (!sources.length) return target
  const source = sources.shift()

  if (source) {
    for (const key in source) {
      if ((source[key] as any) instanceof Object && (target[key] as any) instanceof Object) {
        mergeDeepObjects(target[key], source[key] as any)
      } else {
        target[key] = source[key] as any
      }
    }
  }

  return mergeDeepObjects(target, ...sources)
}


export {
  mergeDeepObjects
}
